import { useClientId } from '../../_hooks/useClientId';

export const useFidelityTokenId = () => {
  const clientId = useClientId();

  const key = `${clientId}-FidelityDocumentVault`;

  const setCurrentTokenId = (tokenId: string) => {
    try {
      localStorage.setItem(key, tokenId);
    } catch (error) {
      console.warn(error);
    }
  };

  const getCurrentTokenId = () => {
    try {
      const storedToken = localStorage.getItem(key);

      if (!storedToken) {
        return undefined;
      }

      return storedToken;
    } catch (error) {
      console.warn(error);
      return undefined;
    }
  };

  return {
    setCurrentTokenId,
    getCurrentTokenId,
  };
};
